var _path, _path2, _path3, _path4;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLogoInfopop(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 77,
    height: 71,
    viewBox: "0 0 77 71",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 70.86V22.67C0.0184751 16.6615 2.41421 10.9045 6.66383 6.65677C10.9134 2.40903 16.6715 0.0158252 22.68 0H76.68V48.19C76.6642 54.1976 74.2706 59.9546 70.0226 64.2026C65.7746 68.4507 60.0176 70.8442 54.01 70.86H0Z",
    fill: "#4CB2D7"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M22.68 8.51001C18.9227 8.51266 15.32 10.0064 12.6632 12.6632C10.0064 15.3201 8.51266 18.9227 8.51001 22.68V62.37H54.04C57.7965 62.3647 61.3976 60.8701 64.0539 58.2139C66.7101 55.5576 68.2047 51.9565 68.21 48.2V8.51001H22.68Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M49.9602 30.77H54.1602V53.27H47.1602L37.9102 34.51H37.7602L38.1102 53.32H33.9202V30.82H40.8502L50.2002 49.63H50.3102L49.9602 30.77Z",
    fill: "#4CB2D7"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M25.45 53.27H21.26V30.77H25.45V53.27Z",
    fill: "#4CB2D7"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoInfopop);
export default __webpack_public_path__ + "static/media/logo_infopop.70d984d3829496d84d7b266fcc96f8ed.svg";
export { ForwardRef as ReactComponent };